<template>
  <div style="padding:50px; padding-top:0px;">
    <v-card
      v-if="$vuetify.theme.dark == true"
      height="550px"
      style="background-color: rgb(39, 39, 39)"
      flat
      class="a slid"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-navigation-drawer v-model="drawer" temporary absolute width="320px">
        <template v-slot:prepend>
          <v-list-item style="background-color: rgb(39, 39, 39)">
            <v-list-item-content
              class="mr-1"
              style="text-align:center; cursor:pointer;"
              @click="model = 0"
            >
              <v-list-item-title @click="model = 0"
                >Cancro Europeu</v-list-item-title
              >
            </v-list-item-content>
            <v-divider vertical></v-divider>
            <v-list-item-content
              class="ml-5"
              style="text-align:center; cursor:pointer;"
              @click="model = 1"
            >
              <v-list-item-title @click="model = 1"
                >Medidas e Manejo</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-divider></v-divider>
        <v-list height="100%" dense style="background-color: rgb(39, 39, 39)">
          <v-carousel
            hide-delimiters
            :show-arrows="false"
            v-model="model"
            height="680px"
          >
            <v-carousel-item v-for="(slide, i) in text1" :key="i">
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      model == 0 ? (modelo = 0) : (modelo = 17);
                      image = 6;
                    "
                    >{{ slide }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      model == 0 ? (modelo = 1) : (modelo = 18);
                      image = 6;
                    "
                    >{{ text2[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      model == 0 ? (modelo = 2) : (modelo = 19);
                      image = 6;
                    "
                    >{{ text3[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      model == 0 ? (modelo = 3) : (modelo = 20);
                      image = 6;
                    "
                    >{{ text4[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      model == 0 ? (modelo = 4) : (modelo = 21);
                      image = 6;
                    "
                    >{{ text5[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      model == 0 ? (modelo = 5) : (modelo = 22);
                      image = 6;
                    "
                    >{{ text6[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      model == 0 ? (modelo = 6) : (modelo = 23);
                      image = 6;
                    "
                    >{{ text7[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      modelo = 7;
                      image = 6;
                    "
                    >{{ text8[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      modelo = 8;
                      image = 6;
                    "
                    >{{ text9[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      modelo = 9;
                      image = 6;
                    "
                    >{{ text10[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      modelo = 10;
                      image = 6;
                    "
                    >{{ text11[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      modelo = 11;
                      image = 6;
                    "
                    >{{ text12[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      modelo = 12;
                      image = 4;
                    "
                    >{{ text13[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      modelo = 13;
                      image = 6;
                    "
                    >{{ text14[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      modelo = 14;
                      image = 3;
                    "
                    >{{ text15[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      modelo = 15;
                      image = 6;
                    "
                    >{{ text16[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      modelo = 16;
                      image = 6;
                    "
                    >{{ text17[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </v-carousel-item>
          </v-carousel>
        </v-list>
      </v-navigation-drawer>
      <div class="dist">
        <imgs
          :items="images"
          :image="image"
          :modelo="modelo"
          :model="model"
          :link="link"
        />
      </div>
    </v-card>
    <v-card
      v-if="$vuetify.theme.dark == true"
      height="550px"
      style="background-color: rgb(39, 39, 39)"
      flat
      class="a noslid"
    >
      <v-navigation-drawer permanent absolute width="320px">
        <template v-slot:prepend>
          <v-list-item style="background-color: rgb(39, 39, 39)">
            <v-list-item-content
              class="mr-1"
              style="text-align:center; cursor:pointer;"
              @click="model = 0"
            >
              <v-list-item-title @click="model = 0"
                >Cancro Europeu</v-list-item-title
              >
            </v-list-item-content>
            <v-divider vertical></v-divider>
            <v-list-item-content
              class="ml-5"
              style="text-align:center; cursor:pointer;"
              @click="model = 1"
            >
              <v-list-item-title @click="model = 1"
                >Medidas e Manejo</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-divider></v-divider>
        <v-list height="100%" dense style="background-color: rgb(39, 39, 39)">
          <v-carousel
            hide-delimiters
            :show-arrows="false"
            v-model="model"
            height="680px"
          >
            <v-carousel-item v-for="(slide, i) in text1" :key="i">
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      model == 0 ? (modelo = 0) : (modelo = 17);
                      image = 6;
                    "
                    >{{ slide }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      model == 0 ? (modelo = 1) : (modelo = 18);
                      image = 6;
                    "
                    >{{ text2[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      model == 0 ? (modelo = 2) : (modelo = 19);
                      image = 6;
                    "
                    >{{ text3[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      model == 0 ? (modelo = 3) : (modelo = 20);
                      image = 6;
                    "
                    >{{ text4[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      model == 0 ? (modelo = 4) : (modelo = 21);
                      image = 6;
                    "
                    >{{ text5[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      model == 0 ? (modelo = 5) : (modelo = 22);
                      image = 6;
                    "
                    >{{ text6[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      model == 0 ? (modelo = 6) : (modelo = 23);
                      image = 6;
                    "
                    >{{ text7[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      modelo = 7;
                      image = 6;
                    "
                    >{{ text8[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      modelo = 8;
                      image = 6;
                    "
                    >{{ text9[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      modelo = 9;
                      image = 6;
                    "
                    >{{ text10[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      modelo = 10;
                      image = 6;
                    "
                    >{{ text11[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      modelo = 11;
                      image = 6;
                    "
                    >{{ text12[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      modelo = 12;
                      image = 4;
                    "
                    >{{ text13[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      modelo = 13;
                      image = 6;
                    "
                    >{{ text14[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      modelo = 14;
                      image = 3;
                    "
                    >{{ text15[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      modelo = 15;
                      image = 6;
                    "
                    >{{ text16[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: rgb(39, 39, 39)">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    @click="
                      modelo = 16;
                      image = 6;
                    "
                    >{{ text17[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </v-carousel-item>
          </v-carousel>
        </v-list>
      </v-navigation-drawer>
      <div class="dist">
        <imgs
          :items="images"
          :image="image"
          :modelo="modelo"
          :model="model"
          :link="link"
        />
      </div>
    </v-card>
    <v-card
      v-if="$vuetify.theme.dark == false"
      height="550px"
      style="background-color: #F2F2F2"
      flat
      class="a slid"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-navigation-drawer v-model="drawer" temporary absolute width="320px">
        <template v-slot:prepend>
          <v-list-item style="background-color: #C4C4C4">
            <v-list-item-content
              class="mr-1"
              style="text-align:center; cursor:pointer;"
              @click="model = 0"
            >
              <v-list-item-title @click="model = 0"
                >Cancro Europeu</v-list-item-title
              >
            </v-list-item-content>
            <v-divider vertical></v-divider>
            <v-list-item-content
              class="ml-5"
              style="text-align:center; cursor:pointer;"
              @click="model = 1"
            >
              <v-list-item-title @click="model = 1"
                >Medidas e Manejo</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-divider></v-divider>
        <v-list height="100%" dense style="background-color: #F2F2F2">
          <v-carousel
            hide-delimiters
            :show-arrows="false"
            v-model="model"
            height="680px"
          >
            <v-carousel-item v-for="(slide, i) in text1" :key="i">
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      model == 0 ? (modelo = 0) : (modelo = 17);
                      image = 6;
                    "
                    >{{ slide }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      model == 0 ? (modelo = 1) : (modelo = 18);
                      image = 6;
                    "
                    >{{ text2[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      model == 0 ? (modelo = 2) : (modelo = 19);
                      image = 6;
                    "
                    >{{ text3[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      model == 0 ? (modelo = 3) : (modelo = 20);
                      image = 6;
                    "
                    >{{ text4[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      model == 0 ? (modelo = 4) : (modelo = 21);
                      image = 6;
                    "
                    >{{ text5[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      model == 0 ? (modelo = 5) : (modelo = 22);
                      image = 6;
                    "
                    >{{ text6[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      model == 0 ? (modelo = 6) : (modelo = 23);
                      image = 6;
                    "
                    >{{ text7[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      modelo = 7;
                      image = 6;
                    "
                    >{{ text8[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      modelo = 8;
                      image = 6;
                    "
                    >{{ text9[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      modelo = 9;
                      image = 6;
                    "
                    >{{ text10[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      modelo = 10;
                      image = 6;
                    "
                    >{{ text11[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      modelo = 11;
                      image = 6;
                    "
                    >{{ text12[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      modelo = 12;
                      image = 4;
                    "
                    >{{ text13[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      modelo = 13;
                      image = 6;
                    "
                    >{{ text14[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      modelo = 14;
                      image = 3;
                    "
                    >{{ text15[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      modelo = 15;
                      image = 6;
                    "
                    >{{ text16[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      modelo = 16;
                      image = 6;
                    "
                    >{{ text17[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </v-carousel-item>
          </v-carousel>
        </v-list>
      </v-navigation-drawer>
      <div class="dist">
        <imgs
          :items="images"
          :image="image"
          :modelo="modelo"
          :model="model"
          :link="link"
        />
      </div>
    </v-card>
    <v-card
      v-if="$vuetify.theme.dark == false"
      height="550px"
      style="background-color: #F2F2F2"
      flat
      class="a noslid"
    >
      <v-navigation-drawer permanent absolute width="320px">
        <template v-slot:prepend>
          <v-list-item style="background-color: #C4C4C4">
            <v-list-item-content
              class="mr-1"
              style="text-align:center; cursor:pointer;"
              @click="model = 0"
            >
              <v-list-item-title @click="model = 0"
                >Cancro Europeu</v-list-item-title
              >
            </v-list-item-content>
            <v-divider vertical></v-divider>
            <v-list-item-content
              class="ml-5"
              style="text-align:center; cursor:pointer;"
              @click="model = 1"
            >
              <v-list-item-title @click="model = 1"
                >Medidas e Manejo</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-divider></v-divider>
        <v-list height="100%" dense style="background-color: #F2F2F2">
          <v-carousel
            hide-delimiters
            :show-arrows="false"
            v-model="model"
            height="680px"
          >
            <v-carousel-item v-for="(slide, i) in text1" :key="i">
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      model == 0 ? (modelo = 0) : (modelo = 17);
                      image = 6;
                    "
                    >{{ slide }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      model == 0 ? (modelo = 1) : (modelo = 18);
                      image = 6;
                    "
                    >{{ text2[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      model == 0 ? (modelo = 2) : (modelo = 19);
                      image = 6;
                    "
                    >{{ text3[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      model == 0 ? (modelo = 3) : (modelo = 20);
                      image = 6;
                    "
                    >{{ text4[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      model == 0 ? (modelo = 4) : (modelo = 21);
                      image = 6;
                    "
                    >{{ text5[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      model == 0 ? (modelo = 5) : (modelo = 22);
                      image = 6;
                    "
                    >{{ text6[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      model == 0 ? (modelo = 6) : (modelo = 23);
                      image = 6;
                    "
                    >{{ text7[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      modelo = 7;
                      image = 6;
                    "
                    >{{ text8[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      modelo = 8;
                      image = 6;
                    "
                    >{{ text9[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      modelo = 9;
                      image = 6;
                    "
                    >{{ text10[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      modelo = 10;
                      image = 6;
                    "
                    >{{ text11[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      modelo = 11;
                      image = 6;
                    "
                    >{{ text12[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      modelo = 12;
                      image = 4;
                    "
                    >{{ text13[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      modelo = 13;
                      image = 6;
                    "
                    >{{ text14[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      modelo = 14;
                      image = 3;
                    "
                    >{{ text15[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      modelo = 15;
                      image = 6;
                    "
                    >{{ text16[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item style="background-color: #F2F2F2">
                <v-list-item-content style="cursor:pointer;">
                  <v-list-item-title
                    style="color:black;"
                    @click="
                      modelo = 16;
                      image = 6;
                    "
                    >{{ text17[i] }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </v-carousel-item>
          </v-carousel>
        </v-list>
      </v-navigation-drawer>
      <div class="dist">
        <imgs
          :items="images"
          :image="image"
          :modelo="modelo"
          :model="model"
          :link="link"
        />
      </div>
    </v-card>
  </div>
</template>

<script>
import content from "../../../../styles/assets/photos.json";
export default {
  components: {
    imgs: () => import("../photos/index.vue")
  },
  data() {
    return {
      drawer: false,
      group: null,
      text1: ["Importância", "Ações para Conscientização dos Fruticultores"],
      text2: [
        "Sintomas Cancro de Papel",
        "Aquisição de Mudas de viveiros com RENASEM"
      ],
      text3: ["Sintomas nos Frutos", "Erradicação ou Não"],
      text4: ["Sintomas na Brotação e Floração", "Manejo de Poda"],
      text5: ["Sintomas na Colheita", "Manejo Pós-Colheita"],
      text6: ["Sintomas na Poda", "Principais Épocas de Monitoramento"],
      text7: ["Sintomas na Queda de Folhas", "Uso de Quebra Ventos"],
      text8: ["Sintomas nos Burrknots", ""],
      text9: ["Sintomas no Líder Central", ""],
      text10: ["Sintomas no Ponto de Colheita", ""],
      text11: ["Sintomas no Raleio", ""],
      text12: ["Sintomas Reflexos", ""],
      text13: ["Sintomas Outros Cancros", ""],
      text14: ["Sintomas Pulgão Lanígero", ""],
      text15: ["Sintomas Toxicidade de Herbicidas", ""],
      text16: ["Sintomas Toxicidade de Manganês", ""],
      text17: ["Epidemiologia", ""],
      model: 0,
      modelo: 0,
      images: content,
      image: 6,
      link: "/imagem"
    };
  },
  watch: {
    group() {
      this.drawer = false;
    }
  }
};
</script>

<style scoped>
@media only screen and (min-width: 1601px) {
  .a {
    margin-left: 200px !important;
    margin-right: 200px !important;
  }
}
@media only screen and (max-width: 836px) {
  .noslid {
    display: none;
  }
}
@media only screen and (min-width: 837px) {
  .dist {
    margin-left: 370px;
  }
  .slid {
    display: none;
  }
}
</style>
